import { ComponentOptions } from 'vue';
import { Vue } from 'vue-property-decorator';
import * as Smart from '../smart';

type SmartComponentNames = keyof typeof Smart;
export function SmartComponentMixin(name: SmartComponentNames): ComponentOptions<Vue> {
  return {
    mounted: function (): void {
      (this as Vue).$x.smart[name] = this as Vue;
    },
    destroyed: function (): void {
      delete (this as Vue).$x.smart[name];
    }
  };
}
